import { Component, Input } from '@angular/core';
import { SVGIcon, filePdfIcon, globeIcon, trackChangesEnableIcon } from '@progress/kendo-svg-icons';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as saveAs from 'file-saver';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../../../auth/authentication.service';
import { CFDocumentToDisplay } from '../../../models/cf-document/cf-document-to-display';
import { CustomNotificationService } from '../../../services/custom-notification.service';
import { CFDocumentStoreService } from '../../../services/documents/cf-document-store.service';
import { CFDocumentService } from '../../../services/documents/cf-document.service';
import { CustomMessagesService } from '../../../services/translation/custom-messages.service';

@UntilDestroy()
@Component({
    selector: 'clfl-document-info-section',
    templateUrl: './document-info-section.component.html',
    styleUrls: ['./document-info-section.component.scss']
})
export class DocumentInfoSectionComponent {
    @Input()
    public document!: CFDocumentToDisplay;
    public globeIcon: SVGIcon = globeIcon;
    public filePdfIcon: SVGIcon = filePdfIcon;
    public trackChangesEnableIcon: SVGIcon = trackChangesEnableIcon;

    constructor(
        private documentService: CFDocumentService,
        private documentStoreService: CFDocumentStoreService,
        private notificationService: CustomNotificationService,
        public authenticationService: AuthenticationService,
        private msgService: CustomMessagesService
    ) {}

    public openGoogleMaps(destinationLocationUrl: string) {
        window.open(destinationLocationUrl, '_blank');
    }

    public openBlockchainExplorer() {
        const fullUrl = environment.blockchainExplorerUrl;
        window.open(fullUrl, '_blank');
    }

    getStatusColor(status: string) {
        switch (status) {
            case 'None':
                return 'badge-info';
            case 'Initiate':
                return 'badge-progress';
            case 'Complete':
                return 'badge-success';
            case 'Cancel':
                return 'badge-danger';
        }

        return '';
    }

    public onFileDownload() {
        this.documentService
            .downloadLatestDocument(
                this.documentStoreService.selectedDocumentType,
                this.documentStoreService.companyId,
                this.document.externalId
            )
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (response: Blob) => saveAs(response),
                error: (err) => {
                    this.notificationService.handleError(this.msgService.translate('cf-document.tab.files.column.downloadError'));
                },
                complete: () => this.notificationService.success(this.msgService.translate('cf-document.tab.files.column.downloadSuccess'))
            });
    }
}
